import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Аркуші',
    DASHBOARDS: 'Інформаційні панелі',
    DATABASE_TABLE: 'Таблиця бази даних',
    VARIABLES: 'Змінні',
    FILES: 'Файли',
    APPS: 'Застосунки',
    LABEL: 'Мітка',
    EDIT_TYPE: 'Редагувати тип',
    EDITING_ROW: 'Редагування рядка {label}',
    CREATE_NEW_ROW: 'Створити новий рядок',
    ADD: 'Додати',
    MULTIPLY: 'Помножити',
    SET: 'Встановити',
    PERCENT_CHANGE: 'Змінити на відсоток',
    NAME: 'Назва',
    NAME_AND_STYLE: 'Назва та стиль',
    PATH: 'Шлях',
    SHARE_WITH: 'Поділитися з',
    SUBMIT: 'Підтвердити',
    EDIT: 'Редагувати',
    ANY: 'Будь-який',
    VIEW: 'Переглянути',
    EDITING: 'Редагування',
    DUPLICATE: 'Дублювати',
    DUPLICATE_SHEET_LOADING: 'Дублювання аркуша...',
    DUPLICATE_SHEET_SUCCESS: 'Дублювання аркуша успішне',
    DUPLICATE_SHEET_ERROR: 'Помилка при дублюванні аркуша',
    DUPLICATE_FOLDER_LOADING: 'Дублювання теки...',
    DUPLICATE_FOLDER_SUCCESS: 'Дублювання теки успішне',
    DUPLICATE_FOLDER_ERROR: 'Помилка при дублюванні теки',
    DELETE_TILE: 'Видалити плитку',
    MATCH_CASE: 'Враховувати регістр',
    SEARCH: 'Пошук',
    SEARCH_VALUES: 'Пошук значень',
    IMPORT: 'Імпортувати',
    MODEL_HEALTH: "Здоров'я моделі",
    CHECKLIST: 'Контрольний список',
    DYNAMIC_ANALYSIS: 'Динамічний аналіз',
    STATIC_ANALYSIS: 'Статичний аналіз',
    CALCULATION_LOGS: 'Журнали обчислень',
    ERROR_MESSAGE: 'Повідомлення про помилку',
    CALCULATION_TIME_MS: 'Час обчислення (мс)',
    ERRORS: 'Помилки',
    WARNINGS: 'Попередження',
    AMPLIFICATION_FACTOR: 'Фактор підсилення',
    CELL_COUNT_ESTIMATE: 'Кількість комірок (оцінка)',
    NO_CALCULATION_ERRORS: 'Немає помилок обчислення',
    CALCULATION_ERRORS: 'Знайдено помилки обчислення',
    NO_MODELLING_ERRORS: 'Немає помилок моделювання',
    MODELLING_ERRORS: 'Знайдено помилки моделювання',
    MODEL_FULLY_LOADED: 'Модель повністю завантажена',
    MODEL_NOT_LOADED: 'Модель не завантажена',
    SHARING: 'Ділитися',
    ASSIGNMENT: 'Завдання',
    ASSIGNMENTS: 'Завдання',
    LOAD_MORE: 'Завантажити ще',
    SHARE: 'Поділитися',
    OPEN: 'Відкрити',
    NONE: 'Нічого',
    TABLE: 'Таблиця',
    VALUE: 'Значення',
    DATE: 'Дата',
    NONE_SELECTED: 'Нічого не вибрано',
    VALUE_FOR_MONTH: 'Значення за місяць',
    DESCRIPTION: 'Опис',
    NOTES: 'Нотатки',
    CUSTOM_FIELD: 'Користувацьке поле',
    TABLE_DESCRIPTION: 'Опис таблиці',
    EDIT_COLUMN: 'Редагувати стовпець',
    COLUMN_TYPE: 'Тип стовпця',
    MONTH: 'Місяць',
    VARIABLE_AND_DIMENSIONS: 'Змінна та виміри',
    SHOW_UNMAPPED: 'Показати непризначені',
    MANUAL_MAPPING: 'Ручне відображення',
    CLEAR: 'Очистити',
    AUTODETECT: 'Автоматичне виявлення',
    FILTER: 'Фільтр',
    SELECT_ALL_BRACKETS: '(Вибрати всі)',
    BLANK_CELLS_BRACKETS: '(Порожні комірки)',
    SELECT_DIMENSIONS: 'Вибрати виміри',
    CONFIRM: 'Підтвердити',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Ви впевнені, що хочете видалити всі відображення?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'Ця дія видалить всі вручну додані теги відображення.',
    ERROR_IMPORTING_FILE: 'Помилка імпорту файлу',
    CHOOSE_JOB_TO_REPLACE: 'Виберіть задачу для заміни',
    PREVIOUS_IMPORTS: 'Попередні імпорти',
    WELCOME_TO_IMPORT: 'Ласкаво просимо до імпорту.',
    IMPORT_SPREADSHEETS: 'Імпортуйте свої електронні таблиці з Excel безпосередньо в Farseer та керуйте ними.',
    DRAG_FILE_HERE: 'Перетягніть ваш файл сюди',
    OR: 'АБО',
    BROWSE: 'Перегляд',
    IMPORT_MISSING_MEMBERS: 'Імпортувати відсутні елементи вимірів',
    IMPORT_VALUES: 'Імпортувати значення',
    NO_COLUMN_SET_AS_TABLE: 'Нема колони, встановленої як розмір',
    NO_COLUMN_SET_AS_VALUE: 'Нема колони, встановленої як значення',
    MISSING_MEMBERS: 'Відсутні елементи виміру',
    SELECT_ALL: 'Вибрати всі',
    DESCRIPTION_COLUMN: 'Стовпець опису',
    CONNECTED_DIMENSIONS_COLUMN: 'Підключений стовпець вимірів',
    CANCEL: 'Скасувати',
    CONTINUE: 'Продовжити',
    CREATE_DIMENSIONS: 'Створити виміри',
    SELECT_CONNECTION: "Вибрати з'єднання",
    CLOSE: 'Закрити',
    SAVE: 'Зберегти',
    DELETE: 'Видалити',
    REMOVE: 'Видалити',
    DELETING_ASSIGNMENT: 'Видалення завдання {multiple}...',
    DELETED_ASSIGNMENT: 'Завдання видалені: {multiple}!',
    FAILED_DELETE_ASSIGNMENT: 'Не вдалося видалити завдання {multiple}',
    DELETE_ASSIGNMENT: 'Видалити завдання {multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Ви хочете видалити вибране завдання {multiple}?',
    COLUMNS: 'Стовпці',
    FORMATTING: 'Форматування',
    PRESERVE_FORMATTING: 'Зберегти форматування',
    CUSTOM_FORMATTING: 'Індивідуальне форматування',
    GROUP_OUTLIERS: 'Групувати викиди',
    VERSIONS: 'Версії',
    NONE_VERSION: 'Відсутні',
    APPLY_TO_ALL_YEARS: 'Застосувати до всіх років',
    SHEET_OPTIONS: 'Параметри аркуша',
    DASHBOARD_OPTIONS: 'Параметри інформаційної панелі',
    LOCK_GRID: 'Заблокувати сітку',
    RESPONSIVE_LAYOUT: 'Адаптивний макет',
    AUTO_REFRESH_DASHBOARD: 'Автооновлення панелі',
    REFRESH_DASHBOARD: 'Оновити панель',
    ONLY_WITH_DATA: 'Лише з даними',
    OWD_INCLUDE_MEASURES: 'Включити показники',
    STACKED: 'Стековані',
    TIMELINE: 'Часова шкала',
    RESET_COLUMN_ORDER: 'Скинути порядок стовпців',
    STANDARD_COLUMNS_NAME: 'Назва',
    STANDARD_COLUMNS_DESCRIPTION: 'Опис',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Назва + опис',
    DOWNLOADING_FILE: 'Завантаження файлу',
    FILE_DOWNLOADED: 'Файл завантажено',
    FAIL_FILE_DOWNLOAD: 'Помилка експорту файлу',
    ADD_TO_DASHBOARD: 'Додати на інформаційну панель',
    SUBMIT_ENTRIES_CONFIRMATION: 'Ви впевнені, що хочете надіслати записи?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Після надсилання ви не зможете вносити зміни і посилання буде заблоковано.',
    LINK_NOT_FOUND: 'Посилання не знайдено.',
    LINK_EXPIRED: 'Закінчився термін дії посилання.',
    DEPLOYMENT: 'Розгортання',
    UNKNOWN: 'Невідомо',
    FILE_SIZE_10GB: 'Розмір файлу > 10 ГБ',
    FILE_SIZE_64MB: 'Розмір файлу > 64 МБ',
    FILE_SIZE_1MB: 'Розмір файлу > 1 МБ',
    FILE_SIZE_TOO_LARGE: 'Розмір файлу занадто великий',
    UPLOADED: 'Завантажено',
    ERROR_UPLOADING_FILE: 'Помилка завантаження файлу',
    FOLDER_NAME: 'Назва теки',
    NEW_DIMENSION_TABLE: 'Нова таблиця вимірів',
    NEW_VARIABLE: 'Нова змінна',
    NEW_DASHBOARD: 'Нова інформаційна панель',
    NEW_SHEET: 'Новий аркуш',
    UPLOAD_FILE: 'Завантажити файл',
    NEW_FOLDER: 'Нова тека',
    NEW_REMOTE_JOB: 'Новий додаток',
    DOWNLOAD: 'Завантажити',
    DELETE_MENU_ITEM_CONFIRM: 'Ви впевнені, що хочете видалити {menuItem}?',
    USER_REMOVED: 'Користувач видалений!',
    FAILED_USER_REMOVE: 'Не вдалося видалити користувача',
    USER_DELETING: 'Видалення користувача {fullName}',
    USER_DELETING_CONFIRM: 'Ви впевнені, що хочете видалити користувача {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Підтвердіть операцію видалення',
    DELETE_YEAR_CONFIRMATION: 'Ви впевнені, що хочете видалити рік {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Ви впевнені, що хочете видалити версію {name}?',
    YEARS: 'Роки',
    YEAR: 'Рік',
    ADD_YEAR: 'Додати {year}',
    OPTIONS: 'Параметри',
    NO_VERSION_SELECTED: 'Версія не обрана',
    INTERVAL_START_GREATER: 'Початок інтервалу більший, ніж деякі кінці інтервалу',
    INTERVAL_END_GREATER: 'Кінець інтервалу менший, ніж деякі початки інтервалу',
    INTERVAL_START_GREATED_END: 'Початок інтервалу більший за кінець',
    NO_NAME_INPUT: 'Завдання має мати назву',
    EDIT_ASSIGNMENTS: 'Редагувати завдання',
    ASSIGNMENT_NAME: 'Назва завдання',
    VERSION: 'Версія',
    ADD_VERSION: 'Додати версію',
    ADD_NEW_VERSION: 'Додати нову версію',
    NEW_VERSION_NAME: 'Назва нової версії',
    ERROR_ADDING_VERSION: 'Помилка додавання версії.',
    NAME_AND_COLOR: "Ім'я та колір",
    ADDED_BY: 'Додав',
    CREATE_SERVICE_USER: 'Створити службового користувача',
    CREATE_USER: 'Створити користувача',
    USER_TYPE: 'Тип користувача',
    STANDARD: 'Стандартний',
    SERVICE: 'Служба',
    CREATED_SERVICE_USER: 'Створено службового користувача',
    FAILED_CREATE_SERVICE_USER: 'Не вдалося створити службового користувача та ключ API',
    SERVICE_USER_NAME_REQUIRED: "Ім'я службового користувача обов'язкове",
    CREATED_USER: 'Користувач створений',
    FAILED_CREATE_USER: 'Не вдалося створити користувача',
    LAST_NAME_REQUIRED: "Прізвище обов'язкове",
    FIRST_NAME_REQUIRED: "Ім'я обов'язкове",
    EMAIL_REQUIRED: "Електронна пошта обов'язкова",
    PASSWORD_REQUIRED: "Пароль обов'язковий",
    PASSWORD_INCORRECT: 'Неправильний пароль',
    FIRST_NAME: "Ім'я",
    LAST_NAME: 'Прізвище',
    EMAIL: 'Електронна пошта',
    PASSWORD: 'Пароль',
    CONFIRM_PASSWORD: 'Підтвердіть пароль',
    API_KEY: 'Ключ API',
    CREATED_SERVICE_USER_API_KEY: 'Створено ключ API службового користувача {serviceUserName} ',
    API_KEY_COPIED_TO_CLIPBOARD: 'Ключ API скопійовано в буфер обміну',
    CONNECT: 'Підключити',
    DISCONNECT: "Від'єднатися",
    MIXED_VERSIONS: 'Змішані версії',
    MIXED: 'Змішане',
    USE_RESTRICTIONS: 'Обмежити введення версіями та інтервалами',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Дозволити введення у стовпцях властивостей',
    PROPERTY_COLUMNS: 'Стовпці властивостей',
    USE_TIME_LIMIT: 'Використовувати обмеження часу',
    SELECT_VERSION: 'Виберіть версію',
    EXPIRES_AFTER: 'Термін дії закінчується після',
    CHANGE: 'Змінити',
    SMART_FILTER_CHANGE: 'Зміна',
    CHANGES_SUBMITTED: 'Зміни підтверджено. Очікується перегляд.',
    SUBMITTED: 'Виконано',
    ASSIGNMENTS_AVAILABLE: 'доступні завдання',
    SUBMITTING_ASSIGNMENT: 'Виконання завдання.',
    SUBMITED_ASSIGNMENT: 'Завдання виконано.',
    FAIL_SUBMIT_ASSIGNMENT: 'Не вдалося підтвердити завдання',
    ASSIGNMENT_LABEL_CREATED: 'Мітка створена і додана до завдання',
    SUBMIT_CHANGES: 'Надіслати зміни?',
    SUBMIT_CHANGES_CONFIRMATION: 'Ви впевнені, що хочете надіслати зміни? Ви не зможете робити подальші зміни, процес буде позначений як готовий до перегляду, і власник цієї таблиці буде сповіщений.',
    CANT_UNDONE_ACTION: 'Ця дія не може бути скасована.',
    APP_LANGUAGE: 'Мова додатка',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Цільова версія не може бути такою самою, як джерело версії',
    TARGET_VERSION: 'Цільова версія',
    SELECT_TARGET_VERSION: 'Будь ласка, виберіть цільову версію.',
    SOURCE_VERSION: 'Вихідна версія',
    SELECT_SOURCE_VERSION: 'Будь ласка, виберіть джерело версії.',
    ROW_TAGS: 'Теги рядка',
    DELETE_THIS_ROW: 'Видалити цей рядок',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Виберіть батьківський тег для генерації декількох рядків',
    GLOBAL_SEARCH_PLACEHOLDER: 'Пошук серед аркушів, інформаційних панелей, таблиць, баз даних та змінних',
    NO_RESULTS_FOUND: 'Не знайдено жодних результатів',
    NEW_TILE: 'Нова плитка',
    SLICER_STATE_SAVED: 'Стан зрізу збережено для всіх!',
    INVALID_LINK: 'Недійсне посилання',
    LINK_NOT_EXIST: 'Посилання не існує.',
    ACCESS_NOT_GRANTED: 'Доступ до хоста не надано.',
    CONTACT_ADMIN: "Будь ласка, зв'яжіться з вашим адміністратором для отримання додаткової інформації.",
    LOGOUT: 'Вийти',
    REGENERATING_LINKS: 'Створення нових посилань...',
    REGENERATED: 'Створено!',
    FAILED_REGENERATING_LINKS: 'Не вдалося створити нові посилання для обраних загальних завдань.',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Створити нові посилання для обраних завдань?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Ви впевнені, що хочете створити нові посилання для обраних завдань? Старі посилання будуть недійсними. Ця дія не може бути скасована.',
    REGENERATE: 'Створити нові',
    REGENERATE_LINK: 'Створити нове посилання',
    SHEET_NOT_FOUND: 'Аркуш не знайдено',
    CLUSTER_NOT_FOUND: 'Кластер не знайдено',
    PARENT_CLUSTER_NOT_FOUND: 'Батьківський кластер не знайдено',
    TAG_NOT_FOUND: 'Тег не знайдено',
    SHEET_ID_NOT_FOUND: 'Ідентифікатор аркуша не знайдено',
    FAIL_CREATE_ROW: 'Помилка створення рядка',
    FAIL_CREATE_CLUSTER: 'Помилка створення кластера',
    ROW_CREATED: 'Рядок створений',
    COLUMN_CREATED: 'Стовпець створено',
    DIMENSION_CREATED: 'Вимір створений',
    NOT_IMPLEMENTED_YET: 'Ще не реалізовано',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Поле змінних має містити лише змінні',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Невідома зона в одному значенні',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Поле фільтра має містити теги виміру',
    UNKNOWN_ZONE_DATA_EDITOR: 'Невідома зона в редакторі даних',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Поле змінних має містити облікові позначки',
    CUSTOM_COLUMN_NOT_FOUND: 'Користувальницька колонка не знайдена',
    CANT_ADD_TO_COLUMN: 'Неможливо додати {tagType} до типу стовпця {columnType}',
    TAG_ALREADY_ADDED: 'Такий тег вже існує',
    MODEL_IMPORT_IN_PROGRESS: 'Імпорт моделі виконується...',
    MODEL_IMPORT_SUCCESS: 'Модель успішно імпортована.',
    CODE_EDITOR_ALLOW_CHANGES: 'Дозвольте редактору коду зробити зміни в моделі:',
    ALLOW_ALL: 'Дозволити все',
    DELETE_MEMBER_ROWS: 'Видалити рядки',
    DELETE_TABLES: 'Видалити таблиці',
    DELETE_VARIABLES: 'Видалити змінні',
    DELETE_COLUMNS: 'Видалити стовпці',
    DELETE_CELLS: 'Видалити комірки',
    DELETE_EVERYTHING: 'Видалити все при застосуванні змін',
    DRY_RUN: 'Пробний запуск',
    MODEL_CODE_EDITOR: 'Редактор коду моделі',
    MODEL_IMPORT_EXPORT: 'Імпорт/Експорт моделі',
    MODEL_IMPORT: 'Імпорт моделі',
    MODEL_EXPORT: 'Експорт моделі',
    MODEL_USE_IN_EXPORT: 'Використовувати при експорті',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Таблиці вимірів',
        DMEM: 'Елементи вимірів',
        VAR: 'Змінні',
        CELL: 'Комірки',
    },
    LOADING: 'Завантаження...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Аналіз вашого питання',
    CHAT_STATS_ACTIONS: '{count} {{дія|дій}}',
    CHAT_STATS_CONTEXT: '{tokens} контексту',
    CHAT_STATS_DURATION_TOOLTIP: 'Скільки часу знадобилося для створення цієї відповіді',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Скільки дій виконав агент (завантаження навичок, запуск коду)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Поточний розмір контексту розмови. Старіші повідомлення узагальнюються, щойно він стає надто великим.',
    CHAT_DEFAULT_TITLE: 'Чат',
    CHAT_ENTER_FULLSCREEN: 'На весь екран',
    CHAT_EXIT_FULLSCREEN: 'Вийти з повноекранного режиму',
    CHAT_RENAME: 'Перейменувати чат',
    CHAT_DELETE: 'Видалити чат',
    CHAT_CREATE_NEW: 'Створити новий чат',
    CHAT_MESSAGE_PLACEHOLDER: 'Повідомлення для FarseerAI...',
    CHAT_SEND: 'Надіслати',
    CHAT_RENAME_TITLE: 'Перейменувати чат',
    CHAT_HELP_QUESTION: 'Чим я можу вам допомогти сьогодні',
    CHAT_SUGGESTED: 'Рекомендовані',
    CHAT_SUGGESTED_SUMMARY: 'Надай мені короткий підсумок моделі',
    CHAT_SUGGESTED_DIMENSIONS: 'Чи є змінні, які мають більше вимірів, ніж змінні, використані в їх формулі?',
    CHAT_SUGGESTED_DELAY: 'Чи використовують якісь змінні функцію delay()?',
    CHAT_SUGGESTED_ON_DEMAND: 'Перелічи всі змінні за запитом',
    CHAT_SUGGESTED_MEASURES: 'Перелічи всі міри',
    CHAT_SUGGESTED_FIXED_DIMENSION: 'Перелічи всі змінні, які використовують фіксований вимір',
    CHAT_SUGGESTED_DATE_PROPERTY: 'Перелічи всі виміри, які мають властивість дати',
    CHAT_CREATED: 'Чат створено!',
    CHAT_CREATED_NEW: 'Новий чат створено!',
    CHAT_RENAMED: 'Чат перейменовано!',
    CHAT_DELETED: 'Чат видалено!',
    CHAT_FAILED_CREATE: 'Не вдалося створити новий чат.',
    CHAT_FAILED_LOAD: 'Не вдалося завантажити чати.',
    CHAT_FAILED_RENAME: 'Не вдалося перейменувати чат.',
    CHAT_FAILED_DELETE: 'Не вдалося видалити чат.',
    CHAT_FAILED_CANCEL: 'Не вдалося скасувати запит.',
    CHAT_FEEDBACK_FAILED: 'Не вдалося зберегти відгук.',
    CHAT_FEEDBACK_THUMBS_UP: 'Хороша відповідь',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Погана відповідь',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Розкажіть нам, що пішло не так',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Що було корисним або що пішло не так? (необов’язково)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Зберегти',
    CHAT_FEEDBACK_CLEAR: 'Очистити відгук',
    CHAT_AGENT_TYPE_ANALYST: 'Аналітик',
    ADVANCED_SETTINGS: 'Розширені налаштування',
    INVALID_JSON_ERROR: 'Недійсний JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Режим обслуговування наразі увімкнено',
    MAINTENANCE_MODE_ENABLED: 'Режим обслуговування в даний час увімкнено',
    CONTACT_ADMIN_FOR_INFO: 'Зачекайте або зверніться до свого адміністратора для отримання додаткової інформації.',
    RETRY: 'Повторити',
    COPY_LINK: 'Копіювати посилання',
    COPY_DATA_FROM: 'Копіювати дані з',
    ROWS_CUT: 'Вирізано рядків',
    ROWS_COPIED: 'Скопійовані рядки',
    ROWS_MOVED: 'Рядки переміщені',
    ROWS_PASTED: 'Вставлені рядки',
    CELLS_CUT: 'Вирізані комірки',
    CELLS_COPIED: 'Скопійовані комірки',
    FAILED_CELLS_COPIED: 'Не вдалося скопіювати комірки {message}',
    CANNOT_CELLS_PASTED: 'Неможливо вставити комірки сюди',
    TAG: 'Тег',
    ACTION: 'Дія',
    MANAGE_CONNECTIONS_FOR: 'Керувати підключеннями для',
    RENAME: 'Перейменувати',
    RENAME_FILE_EXTENSION_REQUIRED: 'Імена файлів мають містити розширення, наприклад .csv або .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Змінити розширення файлу?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'Це змінить розширення з “.{oldExt}” на “.{newExt}”, що може змінити спосіб відкриття файлу. Продовжити?',
    REMOVE_COLUMN: 'Видалити стовпець',
    REMOVE_CONNECTION: "Видалити з'єднання",
    TABLE_CONNECTION: 'Підключення таблиці',
    TEXT: 'Текст',
    TEXT_COLUMN: 'Текстовий стовпець',
    NUMBER: 'Число',
    NUMBER_COLUMN: 'Числовий стовпець',
    NEW_NUMBER_COLUMN: 'Новий числовий стовпець',
    FILE: 'Файл',
    FILE_COLUMN: 'Файловий стовпець',
    DATE_COLUMN: 'Датовий стовпець',
    EDIT_TAG_TYPE: 'Редагувати {tagTypeName}',
    DELETE_TAG_TYPE: 'Видалити {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Видалити дані {tagTypeName}',
    CONNECTIONS: "З'єднання",
    EDIT_CONNECTIONS: 'Редагувати підключення',
    CLEAR_FIELD: 'Очистити поле',
    ERROR_CLEAR_FIELD: 'Помилка очищення поля',
    REPLACE_FILE: 'Замінити файл',
    DOWNLOAD_FILE: 'Завантажити файл',
    DOWNLOAD_ORIGINAL_FILE: 'Завантажити оригінальний файл',
    FILE_DOES_NOT_EXIST: 'Файл не існує',
    DELETE_FILE: 'Видалити файл',
    ERROR_DELETE_FILE: 'Помилка видалення файлу',
    LOCKS: 'Блокування',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Це блокування посилається на видалені сутності',
    TABLE_SETTINGS: 'Налаштування таблиці',
    NEW_MEMBER: 'Новий елемент',
    SORT_TABLE: 'Сортувати таблицю',
    NAME_ASCENDING: 'Назва за зростанням',
    NAME_DESCENDING: 'Назва за спаданням',
    ADD_SORT_RULE: 'Додати правило сортування',
    REMOVE_ALL_SORT_RULES: 'Видалити всі правила сортування',
    '1_SORT': '1 сортування',
    N_SORTS: '{count} сортувань',
    DESCRIPTION_ASCENDING: 'Опис за зростанням',
    DESCRIPTION_DESCENDING: 'Опис за спаданням',
    SORTING_DIMENSIONS: 'Сортування вимірів...',
    DIMENSIONS_SORTED: 'Виміри відсортовані!',
    ERROR_SORTING_DIMENSIONS: 'Помилка сортування вимірів.',
    EDITING_TIMELINE_SLICER: 'Редагування часового зрізу {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Створити новий часовий зріз',
    INTERVAL_START: 'Початок інтервалу',
    INTERVAL_END: 'Кінець інтервалу',
    FORMAT: 'Формат',
    OPERATION: 'Операція',
    MY_PROFILE_INFORMATION: 'Інформація про мій профіль',
    PROFILE_SETTINGS: 'Налаштування профілю',
    ADD_PHOTO: 'Додати фото',
    CHANGE_PHOTO: 'Змінити фото',
    UPDATE_PHOTO: 'Оновити фото',
    REMOVE_PHOTO: 'Видалити фото',
    DECIMAL_SEPARATOR: 'Десятковий роздільник',
    DATE_FORMAT: 'Формат дати',
    DATE_SEPARATOR: 'Роздільник дати',
    ACCESSIBLE_CHART_PATTERNS: 'Шаблони доступності для діаграм',
    SET_AS_DEFAULT_PALETTE: 'Встановити як типову палітру',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Зберегти поточні кольори як палітру',
    DELETE_PALETTE: 'Видалити палітру',
    FILL_STYLE: 'Стиль заливки',
    SOLID: 'Суцільний',
    HATCHED: 'Штрихований',
    VARIABLE: 'Змінна',
    DIMENSION: 'Вимір',
    CREATE_OR_GENERATE_NEW_ROWS: 'Створити або згенерувати нові рядки',
    CREATE_ROW_AS: 'Створити {row} як',
    GENERATE_ROWS_FROM: 'Згенерувати рядок/-ки з',
    CREATE_NEW_VARIABLE: 'Створити нову змінну',
    ENTER_FORMULA_FOR: 'Введіть формулу для {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Виберіть змінну для перегляду або редагування формули',
    DATABASE_AND_PROPERTIES: 'База даних та властивості',
    FOLDER_EMPTY: 'Тека порожня',
    DASHBOARD_EMPTY: 'Інформаційна панель порожня',
    DASHBOARD_HINT: 'Розпочніть роботу з інформаційною панеллю з додавання плитки.',
    YEARS_SETTINGS: 'Налаштування років',
    FINANCIAL_YEAR_STARTING_MONTH: 'Місяць початку фінансового року',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Оновлення місяця початку фінансового року',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Місяць початку фінансового року оновлено',
    SOMETHING_WENT_WRONG: 'Виникла помилка.',
    SEARCH_FOR_USERS: 'Пошук користувачів...',
    SEARCH_FOR_GROUPS: 'Пошук груп...',
    SEARCH_BY_GROUP_OR_USER: 'Пошук за групою або користувачем',
    USERS: 'Користувачі',
    GROUPS: 'Групи',
    USER_OR_GROUP: 'Користувач/Група',
    PERMISSIONS: 'Дозволи',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Кінцева дата повинна бути більшою за початкову дату',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Історичні дані не можуть перекриватися з даними прогнозу',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Будь ласка, виберіть тег рахунку',
    ERROR_STARTING_FORECAST: 'Помилка під час запуску прогнозу',
    CUSTOM_FORECAST: 'Налаштування прогнозу',
    HISTORICAL_DATA_FROM: 'Історичні дані з',
    HISTORICAL_DATA_TO: 'Історичні дані до',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Джерело змінної та вимірів',
    ERROR: 'Помилка {message}',
    FORECAST: 'Прогноз',
    VIEW_FORECASTS_FOR_PERIOD: 'Переглянути прогнози за період',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Немає робіт за обраний період',
    ACTIVE_JOBS: 'Активні роботи',
    FINISHED_JOBS: 'Завершені роботи',
    COMPLETED_ON: 'Завершено {time}',
    FORECAST_PROGRESS: 'Прогрес прогнозу',
    ERROR_LOADING_FORECAST_JOBS: 'Помилка завантаження задач прогнозу.',
    PAGE: 'Сторінка',
    EDIT_ENTRY: 'Редагувати запис',
    NEW_ENTRY_BY_DATE: 'Новий запис за датою',
    TAGS: 'Теги',
    ADD_TAG: 'Додати тег',
    START_YEAR: 'Початковий рік',
    START_MONTH: 'Початковий місяць',
    END_YEAR: 'Кінцевий рік',
    END_MONTH: 'Кінцевий місяць',
    MUST_SELECT_ROW: 'Ви повинні вибрати рядок',
    TITLE: 'Заголовок',
    SUBTITLE: 'Підзаголовок',
    FOOTNOTES: 'Виноски',
    ROW: 'Рядок',
    SELECT_ROW: 'Вибрати рядок',
    COLUMN: 'Стовпець',
    ROW_NAME_DISPLAY: 'Відображення назви рядка',
    BOTH: 'Обидва',
    SHARED_COLUMN_CONFIG_PRESET: 'Спільне налаштування стовпця',
    SHOW_ZERO_SUM_ROWS: 'Показати рядки з нульовими сумами',
    USE_DATA_FROM_TIMELINE_SLICER: 'Використовувати дані з часового зрізу',
    USE_DATA_FROM_DIMENSION_SLICER: 'Використовувати дані зі зрізу виміру',
    DELETE_TARGET_AND_RELATED_DATA: "та пов'язані дані?",
    DELETE_TARGET_CHILDREN: 'Видалити дочірні',
    DELETE_TARGET_DATA: 'Видалити дані для',
    CONFIRM_DELETE_ROW: 'Видалити рядок?',
    CONFIRM_DELETE_ROWS: 'Видалити рядки: {count}?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Видалити згенеровані рядки?',
    CONFIRM_DELETE_ROWS_MIXED: 'Видалити рядки та згенеровані рядки?',
    EXPLAIN_DELETE_ROW: 'Це видалить <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'Це видалить згенеровані рядки з <>{table}<> з цього аркуша.',
    EXPLAIN_DELETE_ROWS_MIXED: 'Це видалить <>{count} рядків<> та згенеровані рядки з <>{table}<> з цього аркуша.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'Це також видалить всі підпорядковані рядки. Цю дію не можна скасувати.',
    FAILED_DELETE_ROW: 'Не вдалося видалити рядок',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'та всі його підпорядковані рядки та елементи?',
    NO_ACCESS_TO_DELETE_ROWS: 'Ви не маєте доступу до зазначених рядків, тому не можете їх видалити.',
    CREATE_GROUP: 'Створити групу',
    EDIT_PERMISSIONS: 'Редагувати дозволи',
    USERS_AND_GROUPS_MANAGEMENT: 'Керування користувачами та групами',
    SUM: 'Сума',
    COUNT: 'Кількість',
    AVERAGE: 'Середнє',
    CLOSING_STATE: 'Кінцевий стан',
    BEGINNING_STATE: 'Початковий стан',
    FORMULA: 'Формула',
    MAX: 'Максимум',
    MIN: 'Мінімум',
    YES: 'Так',
    NO: 'Ні',
    YESTERDAY: 'Вчора',
    CONFIRM_VARIABLE_REMOVE: 'Підтвердіть видалення змінної',
    CONFIRM_VARIABLES_REMOVE: 'Підтвердіть видалення змінних',
    REMOVE_VARIABLE_CONFIRMATION: 'Ви впевнені, що хочете видалити змінну',
    REMOVE_VARIABLES_CONFIRMATION: 'Ви впевнені, що хочете видалити змінні:',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Ви впевнені, що хочете видалити змінні: {tagNumber}?',
    EDIT_VARIABLE: 'Редагувати змінну',
    SHARE_VARIABLE: 'Поділитися змінною',
    DELETE_VARIABLE_DATA: 'Видалити дані змінної',
    DELETE_VARIABLE: 'Видалити змінну',
    EXPAND_MORE: 'Розгорнути більше',
    COLLAPSE_ALL: 'Згорнути все',
    VARIABLE_METRICS: 'Метрики змінної',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Назва',
        Description: 'Опис',
        Formula: 'Формула',
        Dimensions: 'Виміри',
        'Read-only': 'Тільки для читання',
        'Roll-up type': 'Тип згортання',
    },
    LOADING_DATA: 'Завантаження даних…',
    SUCCESSFULLY_LOADED_DATA: 'Дані завантажені',
    LOADING_DATA_FAILED: 'Не вдалося завантажити дані',
    LOADING_DATA_FAILED_SUBTITLE: 'Спробуйте оновити сторінку',
    WAITING: 'Чекаю...',
    VIEW_LOGS: 'Переглянути записи',
    LOADING_DATA_LOG: 'Лог завантаження даних',
    CALCULATION_STARTED: 'Розпочалося обчислення',
    CALCULATION_FINISHED: 'Обчислення завершилося',
    DATABASE_LOADED: 'База даних завантажена. Кількість завантажених комірок: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Обчислення змінної {variableName} розпочалося. Кількість вхідних комірок: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Обчислення змінної {variableName} завершилося. Кількість комірок: {numberOfCells}, вихідний/вхідний коефіцієнт: {outInFactor}.',
    NEW_ROW: 'Новий рядок',
    NEW_TEMPLATE_OR_ROW: 'Новий',
    ADD_TEMPLATE_TO_TOOLBAR: 'Додати на панель інструментів',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Видалити з панелі інструментів',
    IN_TOOLBAR: 'На панелі інструментів',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Шаблон додано на панель інструментів',
    TEMPLATES: 'Шаблони',
    SELECT_A_ROW: 'Вибрати рядок',
    FILE_CANT_BE_PREVIEWED: 'Файл не може бути переглянутий',
    THIS_TYPE_OF: 'Цей тип',
    INPUT_SETUP: 'Налаштування введення',
    ONDEMAND_CALCULATION: 'Обчислення на вимогу',
    REFRESH_DATA: 'Оновити дані',
    DISABLE_MAINTENANCE_MODE: 'Вимкнути режим обслуговування',
    ENABLE_MAINTENANCE_MODE: 'Увімкнути режим обслуговування',
    SAVED: 'Збережено',
    FORMULA_ERROR: 'Помилка формули',
    UNEXPECTED: 'Неочікувано',
    INVALID_SYNTAX: 'Невірний синтаксис для',
    MISSING_TOKEN_AFTER: 'Відсутній токен після',
    UNNECESSARY: "Необов'язковий",
    ERROR_MESSAGE_OCCURRED: 'Виникла помилка',
    INCOMPLETE_sheet_ITEM_DATA: 'Неповні дані елемента аркуша',
    FAIL_SAVE_sheet_ITEMS: 'Не вдалося зберегти елементи аркушу',
    HEADER_COLUMNS: {
        Description: 'Опис',
        Date: 'Дата',
        Version: 'Версія',
        'Variable and Dimensions': 'Змінна та виміри',
        Value: 'Значення',
        'Value type': 'Тип значення',
        Action: 'Дія',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Оновлення описів для тегів місяця та року до дати не вдалося.',
    COMPARISON: 'Порівняння',
    DISALLOW: 'Заборонити',
    USE_DEFAULT: 'Використовуйте за замовчуванням',
    SKIP_ROW: 'Пропустити рядок',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Не дозволяється імпортувати, доки є відсутні елементи вимірів.',
    MISSING_MEMBERS_SKIP_ROWS: 'Пропустить рядки з відсутніми елементами вимірів.',
    MISSING_MEMBERS_DEFAULT: 'Імпортуватиме дані з відсутніх елементів до типового елемента виміру.',
    CONFIGURE_JOB_OPTIONS: 'Налаштувати параметри задачі',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Обробка відсутніх елементів виміру',
    IMPORT_ZEROS: 'Імпортувати нульові значення',
    OVERWRITE_CELLS: 'Перезаписати комірки',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Ігнорувати зміщення фінансового року',
    SKIP_EMPTY_ROWS: 'Пропустити порожні рядки',
    SKIP_REPEATING_HEADER_ROWS: 'Пропустити повторювані рядки заголовків',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Пропустити рядки з низькою інформативністю (евристика)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Під час імпорту буде пропущено {count} рядок(ів).',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Під час імпорту не буде пропущено жодного рядка.',
    INCLUDE_IN_IMPORT: 'Включити до імпорту',
    EXCLUDE_FROM_IMPORT: 'Виключити з імпортування',
    MISSING_MEMBERS_REPLACE_ALL: 'Замінити всі попередні елементи виміру',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Ви впевнені, що хочете замінити всі попередні елементи виміру?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Застосувати елементи та змінні до значень стовпців',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Отримано неправильний тип результату для стовпця {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Спробували створити не унікальні теги',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: "Спробували створити тег з порожнім ім'ям",
    NO_PARENT_TAG_SELECTED: 'Батьківський тег не обрано',
    COLUMN_MANAGER: 'Стовпці',
    NO_COLUMNS: 'Нема стовпців',
    NEW_COLUMN_TIP: 'Ви можете почати з додавання нового елемента стовпця. Потім використовуйте бічну панель для вибору та створення власних стовпців.',
    NEW_COLUMN: 'Новий стовпець',
    COLUMN_TO_NUMBER_TYPE: 'Змінити на число',
    COLUMN_TO_COMPARISON_TYPE: 'Змінити на порівняння',
    COMPARISON_OPERATION: 'Операція',
    DROP_ELEMENTS: 'Викинути елементи...',
    READONLY: 'Тільки для читання',
    CUSTOM_TITLE: 'Власний заголовок',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Виберіть рядок для видалення елементів',
    CANT_MOVE_ROW_INSIDE_SELF: 'Неможливо перемістити рядок всередині себе',
    CLEAR_ALL: 'Очистити все',
    MIGRATE_TO_SHEET: 'Міграція на аркуш',
    CHOOSE_TIME_PERIOD: 'Будь ласка, виберіть період',
    NO_VARIABLE: 'Немає змінної',
    NO_ROWS_SELECTED: 'Не вибрано жодного рядка',
    STARTING_YEAR_NOT_ACTIVE: 'Початковий рік не активний',
    SHEET: 'Аркуш',
    ASSIGNEE: 'Виконавець завдання',
    APPROVER: 'Затверджувач',
    SHARED_TO: 'Спільно з',
    PUBLIC: 'Публічний',
    PUBLIC_LINK: 'Публічне посилання',
    VERSIONS_AND_INTERVAL: 'Версії та інтервал',
    INTERVAL: 'Інтервал',
    EXPIRES_IN: 'Закінчується через',
    STATUS: 'Статус',
    STATUS_EXPIRES_IN: 'Статус (Закінчується через)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Посилання на загальнодоступне завдання скопійовано в буфер обміну',
    EXPORTING: 'Експортування...',
    APPROVE: 'Затвердити',
    DISAPPROVE: 'Відхилити',
    EXPORT: 'Експортувати',
    EXPIRE: 'Закінчити',
    REFRESH: 'Оновити',
    NO_ASSIGNMENTS_AVAILABLE: 'Немає доступних завдань',
    MARK_IN_REVIEW: 'Позначити як в огляді',
    MARK_AS_UNRESOLVED: "Позначити як нерозв'язане",
    MARK_AS_RESOLVED: 'Позначити як вирішене',
    GO_TO_ROW: 'Перейти до рядка',
    DELETE_THREAD: 'Видалити нитку',
    REPLAY_OR_TAG_IN_COMMENT: 'Відповісти або позначити інших за допомогою @...',
    COMMENT_OF: 'Коментар {arrowsCurrent} з {arrowsAll}',
    COMMENT: 'Коментар',
    COMMENTS: 'Коментарі',
    LOADING_IMPORT_JOBS: 'Завантаження задач по імпорту',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Набір даних занадто великий для повного відображення. Показано лише перші 200 000 рядків. Усі рядки будуть імпортовані при підтвердженні.',
    SELECTED_JOB_DOESNT_EXIST: 'Вибрана задача не існує',
    GO_BACK_TO_IMPORT: 'Повернутися до імпорту',
    BACK_TO_IMPORT: 'Назад до імпорту',
    AT_LEAST_ONE_CHART_LINE: 'Ви повинні додати принаймні одну лінію діаграми.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Ви повинні додати принаймні один тег осі x',
    VISUALIZATION_TYPE: 'Тип візуалізації',
    VISUALISATION_OPTIONS: 'Параметри візуалізації',
    EDIT_CHART: 'Редагування діаграми "{title}"',
    BAR_CHART: 'Стовпчаста діаграма',
    BAR: 'Стовпець',
    STACKED_BAR_CHART: 'Складена стовпчаста діаграма',
    STACKED_BAR: 'Складений стовпець',
    WATERFALL_CHART: 'Каскадна діаграма',
    WATERFALL: 'Каскад',
    PIN_CHART: 'Шпилькова діаграма',
    PIN: 'Шпилька',
    AREA_CHART: 'Діаграма з областями',
    AREA: 'Область',
    STACKED_AREA_CHART: 'Складена діаграма з областями',
    STACKED_AREA: 'Складена область',
    LINE_CHART: 'Лінійна діаграма',
    LINE: 'Лінія',
    COMBO_CHART: 'Комбінована діаграма',
    PIE_CHART: 'Кругова діаграма',
    TRAFFIC_LIGHT: 'Світлофор',
    INDICATOR: 'Індикатор',
    SINGLE_VALUE: 'Одиночне значення',
    CREATE_CHART: 'Створити нову діаграму',
    ORIENTATION_LAYOUT: 'Орієнтація та макет',
    HORIZONTAL: 'Горизонтальний',
    VERTICAL: 'Вертикальний',
    SINGLE: 'Одиночний',
    GRID: 'Сітка',
    THIN: 'Тонкий',
    THICK: 'Товстий',
    DOUBLE: 'Подвійний',
    DOT: 'Крапка',
    CIRCLE: 'Коло',
    SQUARE: 'Квадрат',
    CATEGORY_AXIS: 'Вісь категорій',
    DOMAIN_AXIS: 'Вісь домену',
    SHOW_TOTALS: 'Показати підсумки',
    SHOW_AXIS: 'Показати вісь',
    SHOW_VALUE_AXIS: 'Показати вісь значень',
    SHOW_CATEGORY_AXIS_LABELS: 'Показати мітки осі категорій',
    LABEL_FORMAT: 'Формат мітки',
    SHOW_LEGEND: 'Показати легенду',
    SHOW_INTEGRATED_LEGEND: 'Показати інтегровану легенду',
    VALUE_LABELS: 'Мітки значень',
    ROW_VALUE_LABELS: 'Мітки значень рядків',
    SHOW_VALUE_LABELS: 'Показати мітки значень',
    POSITION: 'Позиція',
    SMART_FILTERING: 'Розумне фільтрування',
    TRANSPOSE_DATA: 'Використовувати стовпці як серії',
    NORMALIZE_TO_PERCENT: 'Нормалізувати до 100%',
    SHOW_EMPTY_ROWS: 'Показати порожні рядки',
    SHOW_EMPTY_COLUMNS: 'Показати порожні стовпці',
    GROUP_BY_PARENT_ROW: 'Групувати за батьківським рядком',
    ACCUMULATE_DATA: 'Обчислити поточну суму',
    COLOR_BY_VALUE: 'Забарвлення на основі значення',
    COLOR_BY_TREND: 'Забарвлення на основі тренду',
    COLOR_TOTALS_BY_VALUE: 'Розфарбувати підсумки за значенням',
    USE_SHARED_SCALE: 'Використовувати спільну шкалу',
    STATIC: 'Статичний',
    BY_VALUE: 'За значенням',
    BY_TREND: 'За трендом',
    BAR_SPACING: 'Відстань між стовпцями',
    GAP: 'Відступ',
    WIDTH: 'Ширина',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Використовувати дані з вимірювальних зрізів',
    X_AXIS_DIMENSION_BUILDER: 'Будівельник вимірів осі X',
    ADD_REMOVE_X_AXIS_COLUMN: 'Додати/видалити стовпець осі x',
    Y_AXIS_ITEMS: 'Елементи осі Y',
    ADD_CHART_LINE: 'Додати лінію діаграми',
    UNLOCK_HIERARCHY: 'Розблокувати ієрархію',
    LOCK_HIERARCHY: 'Заблокувати ієрархію',
    MATERIALIZE: 'Матеріалізувати',
    MORE_OPTIONS: 'Більше варіантів',
    LOCK_ROW: 'Заблокувати рядок',
    LOCK_COLUMN: 'Заблокувати стовпець',
    PASTE: 'Вставити',
    COPY: 'Копіювати',
    CUT: 'Вирізати',
    PASTE_ROWS: 'Вставити рядок(и)',
    COPY_ROWS: 'Копіювати рядок(и)',
    CUT_ROWS: 'Вирізати рядок(и)',
    MOVING_ROWS: 'Переміщення рядків...',
    PASTING_ROWS: 'Вставка рядків...',
    CONFIRM_LOCK: 'Підтвердити блокування',
    CONFIRM_UNLOCK: 'Підтвердити розблокування',
    CONFIRM_LOCK_AND_CHILDREN: 'Ви впевнені, що хочете заблокувати цей рядок і його підпорядковані?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Ви впевнені, що хочете розблокувати цей рядок і його підпорядковані?',
    SEARCH_FOR_IMPORTS: 'Шукати імпорти',
    NEW_IMPORT: 'Новий імпорт',
    IMPORTER: 'Імпортер',
    CREATION_DATE: 'Дата створення',
    ACTIONS: 'Дії',
    ADD_ACTION: 'Додати дію',
    ADD_ARGUMENT: 'Додати аргумент',
    EDIT_ACTION: 'Редагувати дію',
    ACTION_NAME: 'Назва дії',
    ARCHIVE: 'Архівувати',
    REPLACE: 'Замінити',
    STATUS_MESSAGE_MAP: {
        'In progress': 'Виконується',
        Commited: 'Виконано',
        Archived: 'Архівовано',
        Reverted: 'Повернуто',
    },
    EDIT_TILE: 'Редагувати плитку',
    FOCUS_TILE: 'Фокусувати елемент',
    UNFOCUS_TILE: 'Скасувати фокус елемента',
    MOVE_TO: 'Перемістити до',
    ADD_ROW: 'Додати рядок',
    ADD_COLUMN: 'Додати стовпець',
    EDIT_ROW: 'Редагувати рядок',
    FROM: 'Від',
    TO: 'До',
    GLOBAL_FORMATTING: 'Глобальне форматування',
    FAIL_SAVE_CHANGES: 'Не вдалося зберегти зміни',
    TAG_NAME_EXISTS: 'Вже існує тег з такою назвою.',
    MUST_CHOOSE_TYPE: 'Ви повинні вибрати тип',
    MUST_ENTER_TAG_NAME: 'Необхідно ввести назву тегу',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Назва тегу не може містити лапки',
    INVALID_VARIABLE_TAG_FORMAT: 'Невірний формат тегу змінної: {tagFormat}',
    INVALID_FORMULA: 'Невірна формула',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Функція {image} не дозволена на тегах вимірів.',
    CREATE_DATABASE_OBJECT: "Створити об'єкт бази даних",
    EDIT_TAG_TYPE_NAME: 'Редагувати {tagType} "{tagName}"',
    PARENT: 'Батьківський',
    ROOT: 'Корінь',
    SEARCH_OR_SELECT_PARENT_TAG: 'Пошук або вибір батьківського тегу',
    ROLLUP_TYPE: 'Тип згортання',
    DATA_TYPE: 'Тип даних',
    FORMAT_TYPE: 'Тип формату',
    CHOOSE_FORMATTING_OPTION: 'Виберіть параметр форматування',
    ENTER_CUSTOM_FORMAT: 'Введіть користувацький формат',
    CUSTOM_FORMAT: 'Власний формат',
    TOP_DOWN: 'Зверху вниз',
    TOP_DOWN_DATA_MAPPING: 'Картографування даних зверху вниз',
    CONNECTED: 'Підключено',
    ADD_CONNECTED_VARIABLE: 'Додати підключену змінну',
    REVERSE_CONNECTED: 'Зворотно підключено',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Додати зворотно підключену змінну',
    DIMENSIONS: 'Виміри',
    ADD_DIMENSION: 'Додати вимір',
    ADVANCED: 'Розширений',
    CALCULATE_ON_DEMAND: 'Обчислити за запитом',
    TRIGGER_ON_DEMAND_CALCULATION: 'Для запуску обчислення за запитом, перейдіть до "Input Setup"',
    OPTIMIZE_CALCULATION: 'Оптимізувати обчислення',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Обмежений легкий зверху вниз',
    USE_HIERARCHY_IN_CALCULATION: 'Використовувати ієрархію в обчисленні',
    MAPPING_TO_VARIABLE: 'Мапування на змінну',
    ADD_FROM_VERSION: 'Додати з версії',
    MAPPING_FROM_VERSION: 'Мапування з версії',
    MAPPING_TO_VERSION: 'Мапування на версію',
    ADD_TO_VERSION: 'Додати до версії',
    USED_IN_FORMULA: 'Використовується в 1 формулі',
    USED_IN_FORMULAS: 'Використовується в {numberOfTags} формулах',
    TABLE_BACKLINKS: 'Згадується в {{1 таблиці|?? таблицях}}',
    VARIABLE_BACKLINKS: 'Використовується в {{1 змінній|?? змінних}}',
    ACTIVE: 'Активний',
    CONNECTED_DIMENSION: 'підключений вимір',
    MY_ACCOUNT: 'Мій обліковий запис',
    SIGN_OUT: 'Вийти',
    LOG_OUT: 'Вийти',
    EDIT_PROFILE: 'Редагувати профіль',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    PROFILE_AND_SUPPORT: 'Профіль і підтримка',
    RENAME_TABLE: 'Перейменувати таблицю',
    SHARE_TABLE: 'Поділитися таблицею',
    DELETE_TABLE_DATA: 'Видалити дані таблиці',
    DELETE_TABLE_MEMBERS: 'Видалити елементи таблиці',
    DELETE_TABLE_DIMENSIONS: 'Видалити виміри таблиці',
    DELETE_TABLE: 'Видалити таблицю',
    DELETE_ROW: 'Видалити рядок',
    DELETE_ROWS: 'Видалити рядки',
    SHOW_VALUE: 'Показати значення',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Показати змінні та виміри',
    FREEZE_ROW_COLUMNS: 'Закріпити рядки/стовпці',
    HIDE_GRIDLINES: 'Приховати сітку',
    HIDE_ROW_COLUMN_HEADERS: 'Сховати заголовки рядків/стовпців',
    LABELS: 'Мітки',
    ADD_LABEL: 'Додати мітку',
    ERROR_LABEL_EXISTS: 'Мітка вже існує!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Помилка перейменування мітки задачі імпорту!',
    IMPORT_JOB_LABEL_RENAMED: 'Мітку задачі імпорту перейменовано',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Помилка видалення мітки задачі імпорту!',
    IMPORT_JOB_LABEL_DELETED: 'Мітку задачі імпорту видалено',
    CREATE_OR_SEARCH: 'Створити або шукати..',
    CREATE: 'Створити',
    NAME_AND_DESCRIPTION: 'Назва та опис',
    SUBTOTALS: 'Проміжні підсумки',
    TOTAL: 'Всього',
    DISABLED: 'Вимкнено',
    BEFORE: 'До',
    AFTER: 'Після',
    UNSELECT_ALL: 'Скасувати вибір',
    SAVE_CONFIG_FOR_ALL: 'Зберегти для всіх',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Зберегти зміни конфігурації як типові',
    EDIT_DIMENSION_SLICER: 'Редагування зрізу виміру "{title}"',
    CREATE_DIMENSION_SLICER: 'Створити новий зріз виміру',
    ENABLE_MULTISELECT: 'Увімкнути багатовибірковий',
    DISPLAY_MULTIPLE_VALUES: 'Відображати кілька значень',
    SEARCH_AND_AUTO_SELECT: 'Пошук та автовибір',
    BLANKS: '(Порожні)',
    ENTER_TITLE: 'Введіть назву...',
    TAG_NAME_DISPLAY: 'Відображення назви тегу',
    FILTERS: 'Фільтри',
    ADD_FILTER: 'Додати фільтр',
    BY_DIMENSION: 'За виміром',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Показати лише виміри з даними у...',
    EDIT_SINGLE_VALUE: 'Редагування одиничного значення "{title}"',
    CREATE_SINGLE_VALUE: 'Створити нове одиничне значення',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Залиште порожнім для автоматичного створення',
    FILTER_DIMENSIONS: 'Фільтрувати виміри',
    COMPARISON_DIMENSIONS: 'Порівняльні виміри',
    COMPARISON_CUSTOM_TEXT: 'Порівняльний користувацький текст',
    DATA_ENTRY: 'Введення даних',
    SHOW_BUTTONS: 'Показати кнопки',
    STEP: 'Крок',
    AND: 'та',
    DOWNSTREAM_FILTERS: 'Нижні фільтри',
    TO_TABLE: 'До таблиці',
    FROM_TABLE: 'З таблиці',
    ADD_DOWNSTREAM_FILTER: 'Додати нижній фільтр',
    FLAT: 'Плаский',
    HIERARCHY_MAX_DEPTH: 'Максимальна глибина ієрархії',
    APPLICATION_VERSION: 'Версія додатка',
    CONFIRM_TAG_REMOVE: 'Підтвердіть видалення тегу',
    CONFIRM_TAGS_REMOVE: 'Підтвердіть видалення тегів',
    REMOVE_TAG_CONFIRMATION: 'Ви впевнені, що хочете видалити тег {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Ви впевнені, що хочете видалити теги: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Ви впевнені, що хочете видалити теги: {tagNumber}?',
    ERROR_PARSING_NUMBER: 'Помилка при розборі номера',
    ERROR_PARSING_DATE: 'Помилка при розборі дати',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Будь ласка, використовуйте контекстне меню для оновлення файлового стовпця',
    ERROR_PARSING_INPUT_NUMBER: 'Помилка при розборі номеру вводу',
    ERROR_SAVING_DATA: 'Помилка збереження даних',
    DATA_ENTRY_NOT_ALLOWED: 'Введення даних не дозволяється',
    ERROR_PARSING_STEP_VALUE: 'Помилка при розборі значення кроку',
    TAG_NAME_CELLS: '{tagName}, комірок: {cellNumber}',
    UNKNOWN_VARIABLE_CELLS: 'Невідома змінна, комірок: {cellNumber}',
    SUCCESS_IMPORTED_CELLS: 'Успіх! Імпортовані комірки: {accountTags}',
    IMPORTED_CELLS: 'Імпортовані комірки',
    IMPORT_JOB_DELETING: 'Видалення імпортного завдання',
    IMPORT_JOB_DELETING_CONFIRM: 'Ви впевнені, що хочете видалити імпортне завдання {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Видалити й зберегти дані',
    DELETE_JOB_AND_DATA: 'Видалити роботу й дані',
    ADD_DIMENSIONS_TO_JOB: 'Додати виміри до задачі',
    CONFIGURE: 'Налаштувати',
    ADD_DESCRIPTION_FOR_IMPORT: 'Додати опис для цього імпорту',
    UNDO: 'Скасувати',
    SETTINGS: 'Налаштування',
    BASIC_SETTINGS: 'Основні налаштування',
    OTHER_SETTINGS: 'Інші налаштування',
    TABLE_NAME: 'Назва таблиці',
    AUTOGENERATE_DIMENSION_NAMES: 'Автоматичне генерування назв вимірів',
    AUTOGENERATE_NAMES_CONFIG: 'Налаштування автоматичного створення назв',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'напр. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Визначте власну конфігурацію для автоматичного генерування імені для цієї таблиці. Використовуйте передвизначені токени нижче з фігурними дужками. Можна вставити будь-який символ між токенами.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Ви можете використовувати ці токени для визначення конфігурації',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (березня 20, 2023 року)',
    ENTRY: 'Вхід',
    STEP_MUST_BE_NUMBER: 'Крок має бути числом',
    EDIT_DATA_EDITOR: 'Редагування редактора даних "{title}"',
    BUTTON_CONTROLS: 'Керування кнопками',
    BOLD: 'Жирний',
    ITALIC: 'Курсив',
    UNDERLINED: 'Підкреслений',
    OUTLINED: 'Контур',
    FONT_SIZE: 'Розмір шрифту',
    FILE_SIZE: 'Розмір файлу',
    SMALL: 'Малий',
    MEDIUM: 'Середній',
    LARGE: 'Великий',
    CREATE_NEW_COLUMN: 'Створити новий стовпець',
    EDIT_COLUMN_WITH_LABEL: 'Редагувати стовпець "{label}"',
    COLUMN_TAGS: 'Теги стовпця',
    DELETE_THIS_COLUMN: 'Видалити цей стовпець',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Виберіть батьківський тег для генерації багатьох стовпців',
    USING_SHARED_COLUMN_CONFIG: 'Використання загальної конфігурації стовпця',
    SLICER_GENERATED: 'Створений зріз',
    HEADER_CANNOT_BE_EMPTY: 'Заголовок не може бути порожнім',
    MUST_CHOOSE_A_FORMAT: 'Ви повинні вибрати формат',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Поля для обчислення не можуть бути порожніми',
    ADD_NEW_COLUMN: 'Додати новий стовпець',
    HEADER: 'Заголовок',
    SUBHEADER: 'Підзаголовок',
    TYPE: 'Тип',
    POLARITY: 'Полярність',
    CONDITIONAL_FORMATTING: 'Умовне форматування',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Відносний',
        Absolute: 'Абсолютний',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Позитивне',
        Negative: 'Негативне',
        Neutral: 'Нейтральне',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Звичайний',
        Calculated: 'Обчислений',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Вимкнено',
        Traffic: 'Світлофори',
        Databar: 'Панель даних',
        Colorscale: 'Послідовність кольорів',
        Arrows: 'Стрілки',
    },
    HIDE_NUMBERS: 'Приховати числа',
    COLUMN_ONE: 'Стовпець 1',
    COLUMN_TWO: 'Стовпець 2',
    LITERAL: 'дослівно',
    FUNCTION: 'функція',
    FUNCTIONS: 'Функції',
    EXAMPLE: 'Приклад',
    EDIT_IN: 'Редагувати {type}',
    OPEN_IN_EDITOR: 'Відкрити в редакторі: {type}',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Щотижня у {day} о {time}',
    REMOTE_JOB_SCHEDULED: 'Заплановано {schedule}',
    SCHEDULE: 'Розклад',
    EVERY: 'Кожен',
    EVERY_HOUR_AT: 'Кожну годину в',
    EVERY_DAY_AT: 'Кожен день в',
    RUN_JOB: 'Запустити задачу',
    RUN: 'Запустити',
    QUEUED: 'В черзі',
    RUNNING: 'Виконується',
    UNAVAILABLE: 'Недоступний',
    MINUTES: 'хвилини',
    JOBS: 'Задачі',
    JOB_LOGS: 'Логи задач',
    PREFERRED_RUNNER: 'Бажаний виконавець',
    RUNNER_DISCONNECTED: 'Цей виконавець наразі відключений.',
    RUNNER_IMAGE: 'Образ виконавця',
    RUNNER_IMAGE_TAG: 'Версія',
    LOGS: 'Логи',
    REMOTE_JOBS: 'Додатки',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Версія',
        Year: 'Рік',
        Month: 'Місяць',
        Quarter: 'Квартал',
        'Half Year': 'Півріччя',
        'Year to Date': 'З початку року',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Змінна/Таблиця/Вимір/Група',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Додати нове: {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Ціле число',
        Decimal: 'Десяткове число',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Користувацький',
        Number: 'Число',
        Currency: 'Валюта',
        Percentage: 'Відсоток',
        Date: 'Дата',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Інформаційна панель',
        Sheets: 'Аркуші',
        Import: 'Імпорт',
        'Remote jobs': 'Додатки',
        Dimensions: 'Виміри',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Таблиця вимірів',
        DIMENSION_MEMBER: 'Елемент виміру',
        VARIABLE: 'Змінна',
        FOLDER: 'Тека',
        FUNCTION: 'Функція',
        LITERAL: 'Літерал',
        PROPERTY: 'Властивість',
        FILE: 'Файл',
        DASHBOARD: 'Інформаційна панель',
        REMOTE_JOB: 'Додаток',
        SHEET: 'Аркуш',
        TILE: 'Плитка',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Таблиці вимірів',
        DIMENSION_MEMBER: 'Елементи вимірів',
        VARIABLE: 'Змінні',
        FOLDER: 'Теки',
        FUNCTION: 'Функції',
        LITERAL: 'Літерали',
        PROPERTY: 'Властивості',
        FILE: 'Файли',
        DASHBOARD: 'Інформаційні панелі',
        REMOTE_JOB: 'Додатки',
        SHEET: 'Аркуші',
        TILE: 'Плитки',
    },
    ITEM: 'Елемент',
    ITEM_TYPE: 'Тип елемента',
    FOLDER_ITEM: {
        DASHBOARD: 'Інформаційні панелі',
        DIMENSION_TABLE: 'Таблиці вимірів',
        VARIABLE: 'Змінні',
        SHEET: 'Аркуші',
        FOLDER: 'Теки',
        FARSEER_FILE: 'Файли',
        REMOTE_JOB: 'Додатки',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Інформаційні панелі',
        DIMENSION_TABLE: 'Таблиці вимірів',
        VARIABLE: 'Змінні',
        SHEET: 'Аркуші',
        FOLDER: 'Теки',
        FARSEER_FILE: 'Файли',
        REMOTE_JOB: 'Додатки',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'генерує універсальний унікальний ідентифікатор',
        YYYY: 'вставляє поточний рік',
        YY: 'вставляє останні дві цифри поточного року',
        MM: 'вставляє поточний місяць',
        DD: 'вставляє поточний день',
        SSSSSSSS: 'вставляє послідовний номер з поточної довжини таблиці дітей + 1, визначте довжину за кількістю символів "S" (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Користувачі та дозволи',
        'Users & Groups': 'Користувачі та групи',
        System: 'Система',
        'Input Setup': 'Налаштування введення',
        Locks: 'Блокування',
        'Backup & Restore': 'Резервне копіювання та відновлення',
        'Audit Logs': 'Аудитовані журнали',
        'Export Model': 'Експорт моделі',
        'Import Model': 'Імпорт моделі',
        'Switch Tenants': 'Перемкнути робочий простір',
        Support: 'Підтримка',
        'Help Center': 'Центр підтримки',
        'Contact Support': "Зв'яжіться з підтримкою",
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'відняти',
        divide: 'поділити',
        plus: 'додати',
        multiply: 'помножити',
        percent: 'відсоток',
        'percent thousands': 'відсоток тисяч',
        'difference in %': 'різниця в%',
    },
    STATUS_MAP: {
        Resolved: 'Вирішено',
        Unresolved: 'Невирішено',
        'In Review': 'У процесі перегляду',
        QUEUED: 'У черзі',
        RUNNING: 'Виконується',
        FINISHED: 'Завершено',
        ERROR: 'Помилка',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Створити користувача',
        'Delete User': 'Видалити користувача',
        'Find All Users': 'Знайти всіх користувачів',
        'Get User': 'Отримати користувача',
        'Update User': 'Оновити користувача',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: "Об'єкти бази даних у моделі",
        CLUSTER_FLOW_ADD: 'Додавання рядків',
        YEAR_VERSION_LOCKS: 'Блокування',
        IMPORT: 'Імпорт',
        SEE_ALL_IMPORT_JOBS: 'Переглянути всі завдання імпорту',
        USERS_GROUPS_MANAGEMENT: 'Керування користувачами та групами',
        REMOTE_JOBS: 'Додатки',
        COMMENTS: 'Коментарі',
        TAGS_SIDEBAR: 'Бічна панель баз даних',
        CREDENTIALS: 'Облікові дані',
        INPUT_SETUP: 'Налаштування вводу',
        AUDIT_LOGS: 'Перегляд журналів',
        ASSIGNMENTS: 'Завдання',
        BACKUP_AND_RESTORE: 'Резервне копіювання та відновлення',
        DASHBOARD_TO_IMAGE: 'Перетворити інформаційну панель на зображення',
        CHAT_AI: 'Чат AI',
        DELETE_DIMENSION: 'Видалити вимір',
        FORECAST: 'Прогнозування',
        GOAL_SEEKING_TOP_DOWN: 'Пошук цілі зверху вниз',
        MODEL_IMPEX: 'Імпорт/експорт моделі',
        OWD_MEASURES: 'Тільки з даними для показників',
        FORMULA_QA: 'Перевірка формул',
        USE_HIERARCHY_IN_CALCULATION: 'Оновити "використання ієрархії" у змінних',
        MODEL_HEALTH: "Здоров'я моделі",
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Логотип Farseer',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Редагувати комірки',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Створити теку',
        'Duplicate Folder': 'Подвоїти теку',
        'Search Folders': 'Шукати теку',
        'Get Items in Folder': 'Отримати елементи в теку',
        'Find by Reverse References': 'Знайти за зворотними посиланнями',
        'Move Items': 'Перемістити елементи',
        'Rename Items': 'Перейменувати елементи',
        'Delete Items in Folder': 'Видалити елементи в теці',
        'Share Folder Hierarchy': 'Поділитися ієрархією теки',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': "Створити об'єкт бази даних",
        'Delete Database Object': "Видалити об'єкт бази даних",
        'Get Database Object': "Отримати об'єкт бази даних",
        'Update Database Object': "Оновити об'єкт бази даних",
        'Search Database Objects': 'Пошук об’єктів бази даних',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Створити аркуш',
        'Get Sheet': 'Отримати аркуш',
        'Update Sheet': 'Оновити аркуш',
        'Duplicate Sheet': 'Дублювати арку',
        'Search Rows in Sheet': 'Пошук рядків у таблиці',
        'Get Sheet Data': 'Отримати дані аркушу',
        'Set Sheet Data': 'Встановити дані аркушу',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Створити рядок',
        'Update Row': 'Оновити рядок',
        'Delete Row': 'Видалити рядок',
        'Move Row': 'Перемістити рядок',
        'Duplicate Row': 'Дублювати рядок',
        'Find All Row': 'Знайти всі рядки',
        'Get Row': 'Отримати рядок',
        'Materialize Row': 'Матеріалізувати рядок',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Створити завдання',
        'Add Public Shares': 'Створити публічне завдання',
        'Delete Share': 'Видалити завдання',
        'Get Share': 'Отримати завдання',
        'Update Share': 'Оновити завдання',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Отримати мітку',
        'Create Label': 'Створити мітку',
        'Update Label': 'Оновити мітку',
        'Delete Label': 'Видалити мітку',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Створити файл',
        'Update File': 'Оновити файл',
        'Delete File': 'Видалити файл',
        'Find All Files': 'Знайти всі файли',
        'Get File': 'Отримати файл',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Створити додаток',
        'Update Remote Job': 'Оновити додаток',
        'Find All Remote Jobs': 'Знайти всі додатки',
        'Get Remote Job': 'Отримати додаток',
        'Run Remote Job': 'Запустити додаток',
        'Run Remote Job As A Service': 'Запустити додаток як сервіс',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Відновити резервне копію',
        'Create Backup': 'Створити резервну копію',
        'Search Backups': 'Знайти резервну копію',
        'Download Backup': 'Завантажити резервну копію',
        'Upload Backup': 'Завантажити резервну копію',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Читати модель',
        'Edit Model': 'Редагувати модель',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Створити інформаційну панель',
        'Duplicate Dashboard': 'Дублювати інформаційну панель',
        'Find All Dashboards': 'Знайти всі інформаційні панелі',
        'Get Dashboard': 'Отримати інформаційну панель',
        'Update Dashboard': 'Оновити інформаційну панель',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Дозвіл на функцію',
        FolderClassPermission: 'Дозвіл на клас фасцікли',
        TagClassPermission: 'Дозвіл на клас тегів',
        SheetClassPermission: 'Дозвіл на клас таблиці',
        SheetRowClassPermission: 'Дозвіл на клас рядка таблиці',
    },
    SEARCH_TAGS: 'Пошук тегів...',
    SEARCH_PERMISSIONS: 'Пошук дозволів',
    DEFAULT: 'За замовчуванням',
    FEATURE_PERMISSIONS: 'Дозвіл на функції',
    CLASS_PERMISSIONS: 'Дозвіл на класи',
    ADD_COMMENT: 'Додати коментар',
    SORT: 'Сортувати',
    SORT_BY: 'Сортувати за',
    ASCENDING: 'У зростаючому порядку',
    DESCENDING: 'У спадаючому порядку',
    UNSORT: 'Не сортувати',
    AUTO: 'Авто',
    LEFT: 'Ліворуч',
    ALL_MONTHS: 'Усі місяці',
    TWELVE_MONTHS: '12 місяців',
    YEAR_START: 'Початок року',
    TIMELINE_START: 'Початок часової шкали',
    COPY_HASH_TAG: 'Копіювати #',
    SHOW_TOP: 'Показати найкращих',
    SHOW_REST: 'Показати решту',
    RIGHT: 'Праворуч',
    CENTER: 'Центр',
    TOP: 'Верх',
    MIDDLE: 'Середина',
    BOTTOM: 'Низ',
    YEAR_END: 'Кінець року',
    TIMELINE_END: 'Кінець часової шкали',
    CURRENT_YEAR: 'Поточний рік',
    PREVIOUS_YEAR: 'Попередній рік',
    CUSTOM: 'Користувацький',
    NEW_TABLE: 'Нова {name}',
    EDIT_TABLE: 'Редагувати {name}',
    FOCUS_TABLE: 'Сконцентруйтеся на {name}',
    ROUND: 'Округлити',
    REGRESSION: 'Регресія',
    RANDOM: 'Випадковий',
    SET_VALUE: 'Встановити значення',
    APPLY_PERCENTAGE: 'Застосувати відсоток',
    APPLY_PERCENTAGE_CHAR: 'Застосувати %',
    DELETE_COLUMNS_ON_ROW: 'Видалити стовпці на рядку',
    PROCESSING_FILE: 'Обробка файлу',
    IMAGE_PREVIEW_FAILED: 'Помилка перегляду зображення',
    NEXT: 'Наступний',
    PREVIOUS: 'Попередній',
    PAGE_OF: 'Сторінка {pageNumber} з {pages}',
    NO_TITLE: 'Без заголовка',
    DURATION: 'Тривалість',
    CELL_COUNT: 'Кількість комірок',
    NONCALCULATED: 'Не обчислюється',
    CALCULATED: 'Обчислюється',
    SEARCH_ASSIGNMENTS: 'Пошук завдань',
    BY_NAME: 'За назвою',
    BY_LABEL: 'За міткою',
    BY_STATUS: 'За статусом',
    BY_SHEET: 'За аркушем',
    GROUP_BY: 'Групувати за',
    CHART_SPACING: 'Інтервал між діаграмами',
    GRID_COLUMNS: 'Стовпці сітки',
    GRID_SPACING: 'Відстань сітки',
    AXIS_SPACING: 'Відстань осей',
    RESET_FILTERS: 'Скидання фільтрів',
    RESET_CONFIG: 'Скидання конфігурації',
    RESET_CONFIG_TOOLTIP: 'Скидання конфігурації на типові налаштування',
    BY_ASSIGNEE: 'За виконавцем',
    BY_APPROVER: 'За затверджуючим',
    NEW_ASSIGNMENT: 'Нове завдання',
    NEXT_ASSGN_DUE: 'Наступне завдання закінчується',
    SHARE_SELECT_USER_PLACEHOLDER: 'Пошук користувачів чи груп...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Створити завдання вибором користувача...',
    ASSIGNMENT_REFRESHED: 'Термін виконання завдання продовжено на 7 днів',
    CANT_EDIT_ASSIGNMENT: 'Неможливо редагувати вже виконані завдання',
    NO_CHANGES: 'Немає змін',
    APPROVED: 'Затверджено',
    EXPIRED: 'Закінчився',
    READY_FOR_REVIEW: 'Готово до перегляду',
    IN_PROGRESS: 'В процесі',
    SHARED: 'Поширено',
    SHARED_WITH: 'Поширено з',
    ARCHIVED: 'Архівовано',
    STILL_STUCK: 'Ще застрягли? Відвідайте наш центр допомоги.',
    NEED_HELP: 'Потрібна допомога? Відвідайте наш центр допомоги.',
    WELCOME: 'Ласкаво просимо',
    WELCOME_MESSAGE: 'Виберіть щось з бічної панелі, щоб почати, або пошукайте щось конкретне.',
    DEFAULT_MEMBER: 'Елемент за замовчуванням',
    FAILED_TO_LOAD_MODEL: 'Помилка завантаження моделі',
    MODEL_LOADED: 'Модель завантажено',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Ваш запит обробляється. Будь ласка, зачекайте...',
    RUN_ARGUMENTS: 'Запустити аргументи',
    EXPECTED_ARGUMENTS: 'Очікувані аргументи',
    RUN_ARGUMENTS_ERROR: 'Помилка запуску аргументів. Вони застаріли, будь ласка, оновіть їх.',
    GENERAL: 'Загальний',
    SYSTEM: 'Система',
    BASIC_INFO: 'Основна інформація',
    LAST_RUN: 'Останній запуск',
    NEVER_RUN: 'Ніколи не запускався',
    REMOTE_JOB_NAME: 'Назва додатку',
    CHOOSE_FOLDER: 'Вибрати теку',
    SOURCE_FOLDER: 'Тека з джерелами',
    SELECT_SOURCE_FOLDER_WARNING: 'Будь ласка, виберіть теку з джерелами',
    MAIN_FILE_HINT: 'Натисніть на таблетку файлу, щоб позначити сценарійний файл як точку входу',
    NO_FILES: 'Немає файлів',
    NO_MAIN_FILE: 'Немає основного файлу',
    FINDER_TOOLTIP: 'Показати структуру',
    VARIABLE_TOOLTIP: 'Показати панель змінних',
    sheet_ITEMS_TOOLTIP: 'Показати детальні значення',
    LIST_ITEMS_TOOLTIP: 'Показати елементи списку',
    EXPAND_TOOLTIP: 'Розгорнути всі рядки на один рівень',
    COLLAPSE_TOOLTIP: 'Згорнути всі рядки на один рівень',
    FORECAST_TOOLTIP: 'Показати прогрес прогнозу',
    EXPORT_TOOLTIP: 'Експорт в .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'Ярлики додатків',
    TAGS_SIDEBAR_TOOLTIP: 'Відкрити бічну панель бази даних',
    TILE_SIDEBAR_TOOLTIP: 'Відкрити бічну панель редагування плитки',
    COMMENTS_SIDEBAR_TOOLTIP: 'Відкрити бічну панель коментарів',
    ADD_APP_SHORTCUT: 'Додати ярлик',
    APP_SHORTCUTS_PATH: 'Ярлики додатків',
    CHANGE_SHORTCUT_ACTION: 'Змінити дію',
    REMOVE_SHORTCUT: 'Видалити ярлик',
    SHORTCUT_ADDED: 'Ярлик успішно додано',
    SHORTCUT_REMOVED: 'Ярлик видалено',
    SHORTCUT_ALREADY_EXISTS: 'Ярлик вже існує',
    CHANGE_ACTION_TITLE: 'Змінити дію',
    CHANGE_ACTION_LABEL: 'Виберіть одну з наступних дій',
    ACTION_CHANGED: 'Дію змінено',
    ERROR_FETCHING_APP_DATA: 'Помилка при отриманні даних додатку',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Помилка при отриманні аргументів дії',
    INVALID_ACTION_ARGUMENTS: 'Недійсні аргументи дії',
    APP_STARTED_SUCCESSFULLY: 'Додаток успішно запущено',
    CREATE_BACKUP: 'Створити резервну копію',
    BACKUP: 'Резервна копія',
    CREATE_BACKUP_WARNING: 'Ви впевнені, що хочете створити нову резервну копію?',
    RESTORE_BACKUP: 'Відновити з резервної копії',
    RESTORE: 'Відновити',
    RESTORE_BACKUP_WARNING: 'Ви впевнені, що хочете відновити з резервної копії {backupPath}?',
    SELECT_MONTH: 'Вибрати місяць',
    REMOVE_FILTER: 'Видалити фільтр',
    FILTER_BY: 'Фільтрувати за...',
    STATIC_FILTER: 'Цей фільтр не можна змінити',
    SELECT_ROW_TO: 'Виберіть рядок для перегляду або зміни його змінної',
    EDIT_ARGUMENT: 'Редагувати аргумент',
    ARGUMENT_NAME: 'Назва аргументу',
    DATA_TYPE_STRING: 'Рядок',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Значення за замовчуванням',
    ADD_OPTION: 'Додати опцію',
    OPTION_VALUE: 'Значення опції',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Опції повинні бути унікальними',
    DROPDOWN_OPTION_EMPTY: 'Опція не може бути порожньою',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Значення за замовчуванням не вибране — під час збереження буде використана перша опція.',
    LOCKED_AT_RUN_TIME: 'Заблокувати значення під час запуску',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Якщо позначено, користувачі під час запуску програми не можуть змінити це значення.',
    LOCKED_REQUIRES_DEFAULT: 'Заблокований аргумент повинен мати значення за замовчуванням',
    SECRET: 'Таємне',
    SECRET_TOOLTIP: 'Значення маскується під час введення та в журналах',
    NAME_REQUIRED: "Назва обов'язкова",
    BACKUP_CREATED: 'Резервна копія створена',
    DOWNLOADING_BACKUP: 'Завантаження резервної копії',
    BACKUP_RESTORED: 'Резервна копія відновлена',
    UPLOAD_BACKUP: 'Завантажити резервну копію',
    UPLOADING: 'Завантаження',
    SHOW_UPLOADED: 'Показати завантажені',
    INITIATED_BY: 'Ініційовано',
    SAVE_AS_IMAGE: 'Зберегти як зображення',
    CREATING_AND_SAVING_IMAGE: 'Створення зображення та збереження у файл...',
    IMAGE_SAVED: 'Зображення збережено!',
    FAILED_TO_SAVE_IMAGE: 'Не вдалося зберегти зображення',
    GOAL_VALUE: 'Цільове значення',
    CURRENT_VALUE: 'Поточне значення',
    PERCENTAGE_MET: 'Виконано {percentage}%',
    UNFREEZE_CELLS: 'Розморозити значення',
    FREEZE_CELLS: 'Заморозити значення',
    UNSET_GOAL: 'Скасувати як цільове значення',
    SET_GOAL: 'Встановити як цільове значення',
    INSPECT_VALUE: 'Огляд значення',
    EDITING_TILE: 'Редагування плитки',
    NO_TILE_SELECTED: 'Будь ласка, виберіть плитку.',
    NO_TILE_OPTIONS: 'Немає доступних опцій.',
    TILE_NAME: 'Назва плитки',
    ENTER_TILE_NAME: 'Введіть назву плитки',
    USE_FILTERS_FROM: 'Використовувати фільтри з',
    USE_SORT_FROM: 'Використовувати сортування з',
    USE_TIMELINE_FROM: 'Використовувати часову шкалу з',
    SHOW_TILE_SORT: 'Показати сортування цієї плитки',
    SHOW_TILE_FILTERS: 'Показати фільтри плитки',
    SHOW_TILE_TIMELINE: 'Показати часову шкалу плитки',
    DASHBOARD: 'Інформаційна панель',
    TILE: 'Плитка',
    CHART_COLUMN_OPTIONS: 'Параметри стовпця',
    CHART_ROW_OPTIONS: 'Параметри рядка',
    GENERAL_STYLING: 'Загальне оформлення',
    PER_ROW_STYLING: 'Стиль для кожного рядка',
    PER_COLUMN_STYLING: 'Стиль для кожного стовпця',
    TEXT_STYLE: 'Стиль тексту',
    ROW_STYLE: 'Стиль рядка',
    COLOR: 'Колір',
    PALETTE: 'Палітра',
    BACKGROUND: 'Фон',
    BORDER: 'Рамка',
    SHADOW: 'Тінь',
    TOP_BORDER: 'Верхня рамка',
    BOTTOM_BORDER: 'Нижня рамка',
    INNER_BORDER: 'Внутрішня рамка',
    RESET_GENERAL_STYLES: 'Скидання загальних стилів',
    RESET_ALL_PER_ROW_STYLES: 'Скидання всіх стилів рядка',
    RESET_ALL_PER_COLUMN_STYLES: 'Скидання всіх стилів стовпця',
    RESET_STYLES: 'Скидання стилів',
    ADD_TABLE: 'Нова таблиця вимірів',
    ADD_VARIABLE: 'Нова змінна',
    ADD_SHEET: 'Новий аркуш',
    ADD_DASHBOARD: 'Нова інформаційна панель',
    ADD_APP: 'Новий додаток',
    ADD_FILE: 'Новий файл',
    ADD_FOLDER: 'Нова тека',
    ENABLED: 'Увімкнуто',
    NEW_TEMPLATE: 'Новий шаблон',
    EDIT_TEMPLATE: 'Редагувати шаблон',
    SAVE_SELECTION_AS_TEMPLATE: 'Зберегти вибірку як шаблон',
    TEMPLATE_CREATED: 'Шаблон створено',
    TEMPLATE_UPDATED: 'Шаблон оновлено',
    TEMPLATE_DELETED: 'Шаблон видалено',
    TEMPLATE_NAME: 'Назва шаблону',
    TEMPLATE_DESCRIPTION: 'Опис шаблону',
    QUANTITY: 'Кількість',
    ENTER_TEXT: 'Введіть текст',
    ENTER_NUMBER: 'Введіть число',
    PICK_A_DATE: 'Виберіть дату',
    ERROR_CREATING_DIMENSION: 'Помилка при створенні нового виміру',
    ALLOW_MULTI_CREATE: 'Дозволити створення кількох елементів одночасно',
    ALLOW_NAME_DESC_CONN_ON_CREATE: "Встановити назву, опис та зв'язки при створенні",
    ALLOW_PROPERTIES_ON_CREATE: 'Встановити властивості при створенні',
    NAMING_CONFIG_ENABLED: '(Конфігурацію назв увімкнено)',
    DIMENSION_TABLE: 'Таблиця вимірів',
    DIMENSION_TABLES: 'Таблиці вимірів',
    DIMENSION_MEMBER: 'Елемент виміру',
    DIMENSION_MEMBERS: 'Елементи виміру',
    ASK_WHEN_CREATING: 'Запитувати під час створення',
    PREDEFINED_CONNECTIONS: "Попередньо визначені зв'язки",
    REQUIRED: 'Потрібно',
    CHOOSE_A_TABLE_FIRST: "Для налаштування зв'язків для шаблону спочатку виберіть таблицю вимірів",
    BIND_TO_TIMELINE: "Пов'язати з часовою шкалою",
    NEW_VARIABLE_COLUMN: 'Новий стовпець змінної',
    NEW_DIMENSION_COLUMN: 'Новий стовпець виміру',
    NEW_LOOKUP_COLUMN: 'Новий стовпець пошуку',
    NEW_COMPARISON_COLUMN: 'Новий стовпець порівняння',
    EDITING_CUSTOM_COLUMN: 'Редагування власного стовпця',
    LOOKUP_PROPERTIES: 'Властивості пошуку',
    CALCULATION_COLUMN: 'Обчислювальний стовпець',
    ADD_COLUMNS: 'Додати стовпці',
    COLUMN_NAME: 'Назва стовпця',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Ви впевнені, що хочете видалити цей стовпець?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Залиште порожнім для автоматичного заповнення назви',
    NOTE_INSPECT_VALUE: 'Примітка: Функція "Переглянути значення" відображає лише до 500 рядків. Для перегляду всіх даних, експортуйте повний набір даних.',
    COPY_FROM: 'Копіювати з',
    PREVIEW: 'Попередній перегляд',
    DECIMALS: 'Десяткові',
    SIGNS: "Від'ємні",
    NEGATIVE_SIGNS: {
        SIGNED: 'Мінус',
        UNSIGNED: 'Без знаку',
        EXPLICIT: 'Плюс/Мінус',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Позитивний',
        NEGATIVE: 'Негативний',
    },
    BASE_UNIT: 'Основна одиниця',
    BASE_UNITS: {
        ONES: 'Одиниці',
        THOUSANDS: 'Тисячі',
        MILLIONS: 'Мільйони',
        BILLIONS: 'Мільярди',
        AUTO: 'Автоматично',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'Січень',
        February: 'Лютий',
        March: 'Березень',
        April: 'Квітень',
        May: 'Травень',
        June: 'Червень',
        July: 'Липень',
        August: 'Серпень',
        September: 'Вересень',
        October: 'Жовтень',
        November: 'Листопад',
        December: 'Грудень',
    },
    MONTHS_SHORT: {
        Jan: 'Січ',
        Feb: 'Лют',
        Mar: 'Бер',
        Apr: 'Кві',
        May: 'Тра',
        Jun: 'Чер',
        Jul: 'Лип',
        Aug: 'Сер',
        Sep: 'Вер',
        Oct: 'Жов',
        Nov: 'Лис',
        Dec: 'Гру',
    },
    DAYS: {
        Sunday: 'Неділя',
        Monday: 'Понеділок',
        Tuesday: 'Вівторок',
        Wednesday: 'Середа',
        Thursday: 'Четвер',
        Friday: "П'ятниця",
        Saturday: 'Субота',
    },
    DAYS_SHORT: {
        Sun: 'Нд',
        Mon: 'Пн',
        Tue: 'Вт',
        Wed: 'Ср',
        Thu: 'Чт',
        Fri: 'Пт',
        Sat: 'Сб',
    },
    CURRENCY: 'Валюта',
    SIGNING_IN: 'Вхід...',
    NEW_RELATION_COLUMN: "Новий стовпець зв'язку",
    SELECT_TABLE_LOOKUP: 'Виберіть таблицю для пошуку',
    SELECT_TABLE_RELATION: "Пов'язати елементи рядка з",
    SELECT_TABLE_PROPERTY: 'Виберіть властивість з таблиці',
    DISPLAY_TABLE_PROPERTY: 'Показати властивість з таблиці',
    FILTER_MEMBERS: 'Фільтрувати вибір елементів фільтрами аркуша',
    TABLE_RELATION: "Зв'язок таблиці",
    FILTER_DISPLAY: 'Фільтрувати відображення',
    RELATE_TABLE: "Пов'язати з таблицею",
    USE_BLANKS: 'Використовувати порожні значення',
    NO_DATA_TO_DISPLAY: 'Немає даних для відображення',
    USE_REFERENCE_FILTERS: 'Використовувати його фільтри',
    USE_REFERENCE_TIMELINE: 'Використовувати його часову шкалу',
    USE_REFERENCE_ROWS: 'Використовувати його рядки',
    USE_REFERENCE_COLUMNS: 'Використовувати його стовпці',
    REFERENCE_ANOTHER_SHEET: 'Посилання на інший аркуш',
    NO_SHEET_SELECTED: 'Аркуш не вибрано',
    SELECT_SHEET: 'Виберіть аркуш',
    SHEET_REFERENCED: "Аркуш успішно прив'язано",
    CANNOT_ADD_ROWS: 'Неможливо додати рядки під час посилання',
    CANNOT_EDIT_ROWS: 'Неможливо редагувати рядки під час посилання',
    CANNOT_EDIT_COLUMNS: 'Неможливо редагувати стовпці під час посилання',
    CANNOT_ADD_COLUMNS: 'Неможливо додати стовпці під час посилання',
    CANNOT_ADD_FILTERS: 'Неможливо додати фільтри під час посилання',
    REVERSE_DIMENSION: 'зворотно підключений вимір',
    REMOVE_FROM_RULE: 'Видалити з правила',
    NEW_RULE: 'Нове правило',
    DUPLICATE_RULE: 'Дублювати правило',
    REMOVE_RULE: 'Видалити правило',
    VARIABLE_LOCK_INFO_TITLE: 'Ця змінна використовуватиме лише це правило.',
    VARIABLE_LOCK_INFO_BODY: 'Інші правила будуть перевизначені. Щоб заблокувати всю змінну, залиште секцію виміру порожньою.',
    DELETED: 'Видалено',
    DONE: 'Готово',
    CHOOSE_ITEMS_TO_EXPORT: 'Виберіть елементи для експорту',
    UPLOAD_MODEL_FILE: 'Завантажте файл моделі',
    NO_FILE_SELECTED: 'Файл не вибрано',
    BACK: 'Назад',
    ALLOW_IMPORT_TO: 'Дозволити імпорт до',
    FINISHED: 'Завершено',
    IMPORT_PREVIEW: 'Це попередній перегляд змін, які імпорт застосує з поточними налаштуваннями.\n\nЗміни:\n',
    IMPORT_FINISHED: 'Імпорт завершено.\n\nЗміни:\n',
    LOADING_MODEL: 'Імпорт моделі з файлу...',
    CUSTOM_COLUMN: 'Користувацький стовпець',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Розгорнути панель рядків та стовпців',
    SEARCH_FOR_EXPRESSIONS: 'Пошук функцій, змінних, вимірів…',
    NEW: 'Новий',
    SELECT_A_CELL: 'Виберіть комірку зі значенням для перегляду формули',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Виберіть комірку для редагування рядків',
    OR_COLUMNS: 'або стовпців',
    MANAGE_PERMISSIONS_FOR: 'Керувати дозволами для "{name}"',
    VIEW_ONLY: 'Тільки перегляд',
    DATA_EDIT: 'Редагування даних',
    EDIT_OWNED: 'Редагувати власні',
    FULL_EDIT: 'Повне редагування',
    UNKNOWN_USER: 'Невідомий користувач',
    UNKNOWN_GROUP: 'Невідома група',
    BUTTON_STYLE: 'Стиль кнопки',
    BUTTON_STYLES: {
        primary: 'Основний',
        secondary: 'Вторинний',
        tertiary: 'Третинний',
        quaternary: 'Четвертинний',
    },
    APP_ICON: 'Іконка застосунку',
    LAST_MODIFIED_BY: 'Останній раз змінив/ла {name}',
    LAST_MODIFIED_BY_COLUMN: 'Останнє змінив',
    LAST_MODIFIED_AT_COLUMN: 'Останнє змінено',
    SHOW: 'Показати',
    FORMULA_QA: 'Перевірка формул',
    TIME_LIMIT: 'Обмеження часу',
    RESTRICTIONS: 'Обмеження',
    SEARCH_FOR_USERS_GROUPS: 'Пошук користувачів або груп…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Пошук або поширення серед користувачів, груп або публічно…',
    STATUS_TRACKING: 'Відстеження статусу',
    STATUS_TRACKING_MESSAGE: 'Відстеження дозволяє користувачу або групі надсилати зміни та запитувати ваше затвердження.',
    TRACK_STATUS: 'Відстежити статус',
    STOP_TRACKING: 'Зупинити відстеження',
    RESTART_TRACKING: 'Перезапустити відстеження',
    ALL: 'Усі',
    TRACKED: 'Відстежувані',
    UNTRACKED: 'Невідстежувані',
    ALL_TRACKED: 'Усі відстежувані',
    MY_TRACKED: 'Мої відстежувані',
    MY_APPROVALS: 'Мої затвердження',
    ALL_SHARES: 'Усі поширення',
    SUPER_USERS: 'Суперкористувачі',
    LOADING_SUPER_USERS: 'Завантаження суперкористувачів...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Неможливо редагувати, коли обмеження часу активне',
    CANNOT_EDIT_WHEN_TRACKED: 'Неможливо редагувати, коли статус відстежується',
    EXPORT_SHARES_TO_XLS: 'Експортувати спільний доступ у .xls',
    SHARE_COPIED: 'Поширення скопійовано!',
    SHARES_COPIED: 'Поширення скопійовані!',
    COPY_SHARE_IN_FOLDER: 'Копіювати на все в цій теці',
    COPY_AND_OVERRIDE_SHARES: 'Копіювати та замінити поширення',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Усі наявні поширення на елементах і теках всередині цієї будуть замінені на поширення поточної теки.',
    COPY_ALL_SHARES_IN_FOLDER: 'Копіювати та замінити всі поширення в цій теці',
    GRID_SINGLE_CHART_EXPLANATION: 'Одна діаграма з рядками верхнього рівня',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Сітка малих діаграм, по одній для кожного рядка верхнього рівня',
    DUPLICATE_KEYS_FOUND: 'Знайдено дублікати ключів',
    DUPLICATE_KEYS_PROMPT: 'Бажаєте відфільтрувати та створити лише унікальні елементи?',
    NAMES_SHOULD_BE_UNIQUE: 'Назви мають бути унікальними',
    LIMIT_TO_FILTERED_OPTIONS: 'Обмежити до відфільтрованих варіантів',

    // Toast messages
    SWITCHING_TENANT: 'Перемикання робочого простору',
    TENANT_SWITCHED_SUCCESS: 'Робочий простір успішно перемкнуто',
    TENANT_SWITCH_FAILED: 'Не вдалося завантажити дані нового робочого простору. Будь ласка, оновіть сторінку',
    FAILED_LOAD_MESSAGES: 'Не вдалося завантажити повідомлення',
    NEW_CHAT_CREATED: 'Новий чат створено!',
    FAILED_LOAD_CHATS: 'Не вдалося завантажити чати.',
    FAILED_CREATE_CHAT: 'Не вдалося створити новий чат.',
    FAILED_SEND_MESSAGE: 'Не вдалося створити новий чат або надіслати повідомлення.',
    FAILED_RENAME_CHAT: 'Не вдалося перейменувати чат.',
    FAILED_DELETE_CHAT: 'Не вдалося видалити чат.',
    XLSX_FILE_ONLY: 'Лише файли .xlsx',
    JSON_FILE_ONLY: 'Лише файли .json',
    EXPORT_DONE: 'Готово!',
    LOCKS_SAVED: 'Блокування збережено',
    COPIED_TO_CLIPBOARD: 'Скопійовано в буфер обміну',
    INVALID_INTERVAL: 'Недійсний інтервал',
    SELECT_REQUIRED_DIMENSIONS: 'Виберіть необхідні виміри.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Тип сутності не вказано',
    FAILED_EXPORT_VARIABLE: 'Не вдалося експортувати змінну: {message}',

    // Button labels
    OK: 'Гаразд',
    DELETE_ENTITY: 'Видалити сутність',
    SAVE_ENTITY: 'Зберегти сутність',
    GENERATED_ENTITIES: 'Згенеровані сутності',
    NEW_ENTITY: 'Нова сутність',
    ENTITIES: 'Сутності',
    SHOW_LOGS: 'Показати журнали',
    CALCULATE: 'Обчислити',
    FORMULA_QA_TITLE: 'Формула QA',
    RENAME_CHAT: 'Перейменувати чат',
    SEND: 'Надіслати',
    EXPORT_CURRENT_SHEET: 'Експортувати поточну таблицю',
    TERMINATE: 'Завершити',
    CONFIRM_UPDATE: 'Підтвердити оновлення',

    // Form labels and placeholders
    FROM_DATE: 'З дати',
    TO_DATE: 'До дати',
    AUDIT_TYPE: 'Тип аудиту',
    SELECT_AUDIT_TYPE: 'Виберіть тип аудиту',
    USER: 'Користувач',
    PAGE_SIZE: 'Розмір сторінки',
    SELECT_PAGE_SIZE: 'Виберіть розмір сторінки',
    SELECT_USER: 'Виберіть користувача',
    EXPORT_EXPANDED_ROWS: 'Експортувати поточно розгорнуті рядки',
    EXPORT_ALL_ROWS: 'Експортувати всі рядки',
    EXPORT_FILENAME_LABEL: 'Назва',
    INCLUDE_CELLS: 'Включити клітинки',
    INCLUDE_MEMBERS: 'Включити членів',
    MESSAGE_FARSEER_AI: 'Повідомлення для FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Введіть нову назву чату',
    FLAG: 'Прапорець',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Надай мені короткий підсумок моделі',
    CHAT_SUGGESTION_DIMENSIONS: 'Чи є змінні, які мають більше вимірів, ніж змінні, використані в їх формулі?',
    CHAT_SUGGESTION_DELAY: 'Чи використовують якісь змінні функцію delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Перелічи всі змінні за запитом',
    CHAT_SUGGESTION_MEASURES: 'Перелічи всі міри',
    CHAT_SUGGESTION_FIXED: 'Перелічи всі змінні, які використовують фіксований вимір',
    CHAT_SUGGESTION_DATE: 'Перелічи всі виміри, які мають властивість дати',

    // Loading defaults
    DEFAULT_LOADING: 'Завантаження...',
    DEFAULT_SUCCESS: 'Успіх!',

    // Audit logs
    TOTAL_RESULTS: 'Всього результатів: {count}',
    PAGE_OF_TOTAL: 'Сторінка {current} з {total}',
    DB_ID: 'ID бази даних',
    DATE_AND_TIME: 'Дата і час',
    LOG_TYPE: 'Тип журналу',
    DATA: 'Дані',

    // Entity debugger
    NO_TYPES: 'Немає типів',

    // Formula QA Modal
    RESULT: 'Результат: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Введіть формулу для обчислення результату.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Експорт вибраних елементів моделі...',

    // Search
    RECENTLY_SEARCHED: 'Нещодавно шукали',
};

export default {
    ...(baseLanguageValues as Translation),
    ...translationValues,
};
